import Config from '../Config'
import CryptoJS from 'crypto-js'
import axios from "axios"

export default class Auth {
  login(user) {
    this.setToken(user.token)
    this.setCompany(JSON.stringify(user.company))
    this.setRole(user.role);
    this.setToken(user.token)
    this.setUserDetails(user.firstName + " " + user.lastName)
    window.location.reload();

  }

  loggedIn() {
    return !!this.getToken()
  }

  setToken(idToken) {
    sessionStorage.setItem('zigloi_userid', idToken)
  }

  getToken() {
    return sessionStorage.getItem('zigloi_userid')
  }

  setRole(idToken) {
    sessionStorage.setItem('zigloi_role', idToken)
  }

  setUserDetails(name) {
    sessionStorage.setItem('zigloi_user', name)
  }
  getUserDetails() {
    return sessionStorage.getItem('zigloi_user')
  }

  getRole() {
    return sessionStorage.getItem('zigloi_role')
  }

  setCompany(code) {
    sessionStorage.setItem('zigloi_company', code)
  }

  getCompany() {
    return sessionStorage.getItem('zigloi_company')
  }

  setCompanySetup(company) {
    sessionStorage.setItem('zcompanysetup', company)
  }

  getCompanySetup() {
    return this.decryptData(sessionStorage.getItem('zcompanysetup'))
  }

  setLanguage(language) {
    sessionStorage.setItem('zigloi_language', language)
  }

  getLanguage() {
    return sessionStorage.getItem('zigloi_language')
  }

  setAuthCode(authToken) {
    sessionStorage.setItem('zigloi_authCode', authToken)
  }

  getAuthCode() {
    return sessionStorage.getItem('zigloi_authCode')
  }

  token() {
    var token = {
      username: this.getToken(),
      password: '',
      companyCode: this.getCompany(),
      code: this.getAuthCode()
    }
    return token;
  }

  logout() {
    this.logoutAudit()
    sessionStorage.removeItem('zigloi_company')
    sessionStorage.removeItem('zigloi_userid')
    sessionStorage.removeItem('zcompanysetup')
    sessionStorage.removeItem('features')
    sessionStorage.removeItem('other_features')
    sessionStorage.removeItem('SysDate')
    sessionStorage.removeItem('loancust')
    sessionStorage.removeItem('zigloi_language')
    sessionStorage.removeItem('zigloi_authCode')
    sessionStorage.removeItem('zigloi_user')

    window.location.reload(true)

  }

  logoutAudit = () => {
    var config = new Config()
    // var $http = config.DConnect()
    var logoutForm = {
      createdon: new Date(), username: this.getToken(), auditType: '9',
      description: this.getToken() + ' logged out of Nyansapo on ' + new Date()
    }

    let formData = this.encryptData(JSON.stringify(logoutForm))
    //alert(JSON.stringify(this.decryptData(formData)))
    axios(config.PostOptions(formData, "report/wapp/" + this.getCompany() + "/logout_trail"))
      .then((res) => {

      });
  }

  getKey() {
    return 'Fg7EZ/RRa0Y='
  }

  encryptData(dt) {
    var keyHex = CryptoJS.enc.Base64.parse(this.getKey())
    var encrypted = CryptoJS.DES.encrypt(dt, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString()
  }

  decryptData(dt) {
    var keyHex = CryptoJS.enc.Base64.parse(this.getKey())
    var decrypted = CryptoJS.DES.decrypt({
      ciphertext: CryptoJS.enc.Base64.parse(dt)
    }, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
  }

  decryptText(dt) {
    var keyHex = CryptoJS.enc.Base64.parse(this.getKey())
    var decrypted = CryptoJS.DES.decrypt({
      ciphertext: CryptoJS.enc.Base64.parse(dt)
    }, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8)
  }

  setFeatures(userole) {
    sessionStorage.setItem('features', userole)
  }

  getFeatures() {
    return sessionStorage.getItem('features')
  }

  setOtherFeatures(userole) {
    sessionStorage.setItem('other_features', userole)
  }

  getOtherFeatures() {
    return sessionStorage.getItem('other_features')
  }

  setSysDate(SysDate) {
    sessionStorage.setItem('SysDate', SysDate)
  }

  getSysDate() {
    return sessionStorage.getItem('SysDate')
  }

  setLoanCust(custid) {
    sessionStorage.setItem('loancust', JSON.stringify(custid))
  }

  getLoanCust() {
    return JSON.parse(sessionStorage.getItem('loancust'))
  }

  destroyLoanCust() {
    sessionStorage.removeItem('loancust')
  }

  setGeneralVar(name, value) {
    sessionStorage.setItem(name, JSON.stringify(value))
  }

  getGeneralVar(name) {
    return JSON.parse(sessionStorage.getItem(name))
  }

  destroyGeneralVar(name) {
    sessionStorage.removeItem(name)
  }

  setLoanSchedule(schedule) {
    sessionStorage.setItem('loanschedule', JSON.stringify(schedule))
  }

  getLoanSchedule() {
    return JSON.parse(sessionStorage.getItem('loanschedule'))
  }

  destroyLoanSchedule() {
    sessionStorage.removeItem('loanschedule')
  }

  setBOGToken(token) {
    sessionStorage.setItem('bog_token', token)
  }

  getBOGToken() {
    return sessionStorage.getItem('bog_token')
  }
}
